import React, { useState } from "react";
import { RCCAlert, RCCGrid } from "react-common-components";
import Loader from "src/components/Loader";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { IDiagnosticContent, IDiagnosticData, IMdtbb001 } from "../../interface";
import DiagnosticTabs from "../DiagnosticTabs";


const DiagnosticContent: React.FC<IDiagnosticContent> = ({
	mdtbb001
}) => {

	const { translate } = useTranslation();
	
	const [diagnosticData, setDiagnosticData] = useState<IDiagnosticData | null>(null);

	const { errorFetching, loading, loadData } = useEffectFetchData<IDiagnosticData> (
		"Diagnostics/SelectDiagnostic", 
		{ 
			id: mdtbb001?.mdb001Id
		},
		({ data }) => {
			setDiagnosticData(data);
		},
	 [mdtbb001]
	);

	return (
		<>
			<RCCGrid
				container
				item
				style={{ marginRight: "1rem" }}
				direction="column"
			>
				{errorFetching ? (
					<RCCAlert 
						color="red"
						title={translate("Atenção")}
						description={translate("Erro ao carregar dados")}
					/>
				): 
					<>
						{loading ? 
							<Loader /> : 
							<>
								<Title color="purple" size="xl">
									{mdtbb001?.mdb001Descricao}
								</Title>
								<Title color="grey" size="xs">
									{mdtbb001?.mda001Titulo}
								</Title>
								<DiagnosticTabs
									selectedDiagnostic={mdtbb001 ?? {} as IMdtbb001}
									mdtba002s={diagnosticData?.mdtba002 ?? []}
									callbackOnClick={loadData}
								/>	
							</>
						}
					</>
				}
			</RCCGrid>
		</>
	);
};

export default DiagnosticContent;
